interface Action {
	type: string;
	payload?: any;
}

export const SHOW_DETAILS_BACK = "SHOW_DETAILS_BACK";
export function showDetailsBack(): Action {
	return {
		type: SHOW_DETAILS_BACK
	}
}
